import { render, staticRenderFns } from "./StepDuplicates.vue?vue&type=template&id=324e6bc3&scoped=true"
import script from "./StepDuplicates.vue?vue&type=script&lang=js"
export * from "./StepDuplicates.vue?vue&type=script&lang=js"
import style0 from "./StepDuplicates.vue?vue&type=style&index=0&id=324e6bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e6bc3",
  null
  
)

export default component.exports